import { Box } from "@nulogy/components";
import Select from "components/controls/Select";
import React from "react";
import DateTime from "utils/DateTime";

function displayNameForDay(day) {
  const map = {
    friday: "Fri",
    monday: "Mon",
    saturday: "Sat",
    sunday: "Sun",
    thursday: "Thu",
    tuesday: "Tue",
    wednesday: "Wed",
  };

  return map[day];
}
const dayOfWeekOptions = DateTime.DAYS_OF_WEEK.map((day) => ({ label: displayNameForDay(day), value: day }));

export default function DaysSelector() {
  return (
    <Box data-testid="days" pr="x2" pt="x1">
      <Select
        className="spec-days-select"
        closeMenuOnSelect={false}
        field="days"
        maxHeight="250"
        multiselect
        options={dayOfWeekOptions}
        placeholder="Days"
      />
    </Box>
  );
}
